import { Pipe, PipeTransform } from '@angular/core';
import { InstallationReceivedPluginService } from './received.service';

@Pipe({
    name: 'documenttype',
    standalone: false
})
export class DocumentTypePipe implements PipeTransform {
  public documentTypes: any[];

  constructor(private service: InstallationReceivedPluginService) {
    this.documentTypes = this.service.getDocumentTypes();
  }

  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.documentTypes);
  }
}
